import { CwtDictionary } from "@cawita/core-front";
import { CwtApiEntity, CwtCrudContract, CwtModel, CwtProp, CwtSchema } from "@cawita/core-front/api";

export type TemplateType = 'mail';
export type TemplateFor = 'company' | 'admin' | 'system';
export type TemplateAttachments = 'mandatory' | 'accepted' | 'none';

export enum TemplateUseCase {
    ForgottenPassword = 'forgottenPassword',
    NewPasswordEmail = 'newPasswordEmail',
    InvitationMail = 'invitationMail',
    InvitationRefused = 'invitationRefused',
    InvitationAccepted = 'invitationAccepted',
    ConfirmationRegisterMail = 'confirmationRegisterMail',
}

export class TemplateSchema extends CwtApiEntity {
    @CwtProp() name: string;
    @CwtProp() type: TemplateType;
    @CwtProp() for: TemplateFor;
    @CwtProp() useCase: string;
    @CwtProp() subject: CwtDictionary;
    @CwtProp() content: CwtDictionary;
    @CwtProp() isActive: boolean;
}

@CwtModel({ name: 'template' })
@CwtCrudContract({ path: 'template' })
export class Template extends TemplateSchema { }